export default __webpack_public_path__ + "static/media/apple.f0d70faa.svg";